import { fabric } from "fabric";
import DEFINE from "../define";
import ToolBase from "../basic";

import editPen from "../../../assets/other_tools/web_link/edit_pen.svg";
import linkTitle from "../../../assets/other_tools/web_link/link_title.svg";
import EventBus from "../../event_bus";
import PainterProxy from "../proxy";

import DefineControl from "../controls";
import ImageControl from "../../record_task/image_control";
import AppRenderer from "../../app_renderer";

export default class insertPicture extends ToolBase {
    name = DEFINE.TOOLS.INSERT_PICTURE;

    point = {
        x: 0,
        y: 0,
    };

    maxSize = 400;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        let self = this;
        let canvas = this.canvas;

        object.set({
            canvas: self,
            toolType: self.name,
            tag: DEFINE.TAG.INSERT_PICTURE + new Date().getTime(),

            controls: Object.assign(this.getBasicControls(), {
                mtr: this.getTouchRotateControl({
                    x: 0.5,
                    y: 0,
                    offsetX: 25,
                    offsetY: 0,
                }),
                deleteControl: this.getDeleteControl({
                    x: 0.5,
                    y: -0.5,
                    offsetX: 25,
                    offsetY: 0,
                }),
            }),
            data: {},
        });

        object.set({
            hasControls: true,
            hasBorders: true,
            subTargetCheck: true,
        });

        DefineControl.Instance.setDefaultControl(object, this);

        object.on("moving", (e) => {
            self.setDragSize(object);
        });

        if (object.type == "Group") {
            object.set("selectable", false);
        } else {
            object.set("selectable", true);
        }

        canvas.renderAll();
    }

    mouseDown(o) {
        let pointer = this.canvas.getPointer(o.e);
        this.parent.proxy.changeTool(null);
        this.point = {
            x: pointer.x,
            y: pointer.y,
        };
        this.init();
    }

    init() {
        EventBus.getInstance().emit("sendInsertPicture", {
            pointer: this.point,
            insertPicture: this,
        });
    }

    createInsertPicture(imgObjUrl, args, fileName) {
        if (imgObjUrl == null || args == null) return;

        let self = this;
        let newX = args.x;
        let newY = args.y;

        console.log(`x: ${newX} y: ${newY}`);
        let canvas = this.canvas;

        const helperObj = new fabric.Object({}); //abstract invisible object
        helperObj.set("selectable", false); //so the user is not able to select and modify it manually
        canvas.add(helperObj);

        fabric.Image.fromURL(imgObjUrl, (objImg) => {
            let imgWidth = objImg.width;
            let imgHeight = objImg.height;

            if (imgWidth - imgHeight < 0) {
                objImg.scaleToHeight(self.maxSize);
            } else if (imgWidth - imgHeight > 0) {
                objImg.scaleToWidth(self.maxSize);
            } else {
                objImg.scaleToHeight(self.maxSize);
            }

            objImg.set({
                canvas: self,
                toolType: self.name,
                tag: DEFINE.TAG.INSERT_PICTURE + new Date().getTime(),
                left: newX,
                top: newY,

                controls: Object.assign(this.getBasicControls(), {
                    mtr: this.getTouchRotateControl({
                        x: 0.5,
                        y: 0,
                        offsetX: 25,
                        offsetY: 0,
                    }),
                    deleteControl: this.getDeleteControl({
                        x: 0.5,
                        y: -0.5,
                        offsetX: 25,
                        offsetY: 0,
                    }),
                }),

                data: {},
                url: imgObjUrl,
                point: {
                    x: newX,
                    y: newY,
                },
            });

            objImg.set({
                hasControls: true,
                subTargetCheck: true,
                hasBorders: true,
            });

            objImg.set({
                imageFileName: fileName,
            });

            DefineControl.Instance.setDefaultControl(objImg, this);

            objImg.on("moving", (e) => {
                self.setDragSize(objImg);
            });

            // self.createImageSize(objImg);
            objImg.setCoords();
            canvas.add(objImg);
            canvas.renderAll();

            let objects = this.canvas.getObjects();
            var selection = new fabric.ActiveSelection(objects, {
                canvas: canvas,
            });

            canvas.setActiveObject(selection);
            canvas.discardActiveObject();
            canvas.requestRenderAll();
            canvas.remove(helperObj);

            this.parent.addHistory();
            console.log(objImg);
        });
    }

    /**
     * 刪除控制器事件
     * @param {*} eventData
     * @param {*} transform
     */
    deleteFunction(eventData, transform) {
        let target = transform.target;
        let canvas = target.canvas;
        console.log(transform, transform.target);
        ImageControl.Instance.removeImage(transform.target.imageFileName)
        AppRenderer.Instance.removeImage(transform.target.imageFileName)

        this.parent.currentTool = null;
        canvas.remove(target);
        canvas.requestRenderAll();

        this.addHistoryFunction();
    }

    getCanvasWidthHeight() {
        let canvas = this.canvas;

        let width = Math.max(canvas.vptCoords.bl.x, canvas.vptCoords.br.x, canvas.vptCoords.tl.x, canvas.vptCoords.tr.x);

        let height = Math.max(canvas.vptCoords.bl.y, canvas.vptCoords.br.y, canvas.vptCoords.tl.y, canvas.vptCoords.tr.y);

        let CanvasSize = {
            width: width,
            height: height,
        };

        return CanvasSize;
    }

    setDragSize(obj) {
        let objectRect = this.updateObjectRect(obj);

        if (obj.left - objectRect.x < 0) {
            obj.set({
                left: 0 + objectRect.x,
            });
        }

        if (obj.left - objectRect.x + objectRect.width > this.canvas.width) {
            obj.set({
                left: this.canvas.width - (objectRect.width - objectRect.x),
            });
        }

        if (obj.top - objectRect.y < 0) {
            obj.set({
                top: 0 + objectRect.y,
            });
        }

        if (obj.top - objectRect.y + objectRect.height > this.canvas.height) {
            obj.set({
                top: this.canvas.height - (objectRect.height - objectRect.y),
            });
        }
    }

    createImageSize(obj) {
        let canvasSize = this.getCanvasWidthHeight();
        if (obj.left < 0) {
            obj.set({
                left: 0,
            });
        }

        if (obj.left + obj.width * obj.scaleX > canvasSize.width) {
            obj.set({
                left: canvasSize.width - obj.width * obj.scaleX,
            });
        }

        if (obj.top < 0) {
            obj.set({
                top: 0,
            });
        }

        if (obj.top + obj.height * obj.scaleY > canvasSize.height) {
            obj.set({
                top: canvasSize.height - obj.height * obj.scaleY,
            });
        }
    }

    //翻轉時 Top left 不會變動，需要自己算出新的 Top left 寬 高
    updateObjectRect(obj) {
        let minPointerX = Math.min(obj.aCoords.bl.x, obj.aCoords.br.x, obj.aCoords.tl.x, obj.aCoords.tr.x);

        let minPointerY = Math.min(obj.aCoords.bl.y, obj.aCoords.br.y, obj.aCoords.tl.y, obj.aCoords.tr.y);

        let maxPointerX = Math.max(obj.aCoords.bl.x, obj.aCoords.br.x, obj.aCoords.tl.x, obj.aCoords.tr.x);

        let maxPointerY = Math.max(obj.aCoords.bl.y, obj.aCoords.br.y, obj.aCoords.tl.y, obj.aCoords.tr.y);

        const rect = {
            x: obj.aCoords.tl.x - minPointerX,
            y: obj.aCoords.tl.y - minPointerY,
            width: maxPointerX - minPointerX,
            height: maxPointerY - minPointerY,
        };

        return rect;
    }
}
